<template>
    <div class="greet" ref="greet">
        <div class="container">
            <div class="icon">Hi!</div>
            <h3 class="name" :title="$store.getters.selfInfo.fullname">{{$store.getters.selfInfo.fullname}}</h3>
            <div class="welcome">欢迎来到旗渡</div>
            <span class="status">{{currentStatus[$store.getters.selfInfo.current_state]}}</span>
        </div>
    </div>
</template>

<script>
    import {throttle} from "../../utils";
    import {userStatus} from "../../utils/statusDict"
    import {whoAreYou} from "../../api/premission";

    export default {
        name: "greet",
        data(){
            return{
                initNum:0,
                scrollHeight: '',
                backTimer: '',
                greetHeight: 0,
                currentStatus:userStatus()
            }
        },
        methods:{
            scrollEvent(){
                try {
                    let scrollHeight = Math.floor(document.body.scrollTop || document.documentElement.scrollTop || window.pageYOffset);
                    this.greetHeight = this.$refs.greet.clientHeight;
                    if((scrollHeight>70&&scrollHeight<150)&&scrollHeight-this.initNum>=0&&scrollHeight<this.greetHeight+80){        // 640
                        this.back()
                    }
                    if(scrollHeight<=this.greetHeight-180){          // 430
                        this.$store.commit("scrollInTop", false)
                    }else{
                        this.$store.commit("scrollInTop", true)
                    }
                    this.initNum = scrollHeight;
                }catch (e) {
                    console.log(e)
                }

            },
            back(){
                var self = this;
                if(!self.backTimer){
                    self.backTimer = setInterval(function () {
                        self.scrollHeight = document.body.scrollTop || document.documentElement.scrollTop;
                        var speed = (self.scrollHeight) / 11;
                        if (document.body.scrollTop!=0) {
                            document.body.scrollTop += speed;
                        }else {
                            document.documentElement.scrollTop += speed;
                        }
                        if(self.scrollHeight > (self.greetHeight-180)){        // 430
                            self.$store.commit("scrollInTop", true)
                            clearInterval(self.backTimer)
                            self.backTimer = ""
                        }
                    }, 20);
                }

            },
            getWhoAmI(){
                if(!this.selfInfo){
                    whoAreYou()
                        .then(data=>{
                            this.$store.commit("permission/SET_INFO", data)
                        }).catch(error=>{
                        console.log(error)
                    })
                }
            }
        },
        mounted() {
            setTimeout(()=>{
                window.addEventListener('scroll', throttle(this.scrollEvent), false)
            },1)
        },
        beforeDestroy() {
            window.removeEventListener('scroll', throttle(this.scrollEvent), false)
        },
        created() {
            this.getWhoAmI()
        }
    }
</script>

<style scoped lang="scss">
    @import "@/assets/css/public/greet.scss";
</style>